export default __webpack_public_path__ + "static/media/logo.f800f33d.svg";